import styled from 'styled-components';

export const PassCodeContainer = styled.div`
	display: flex;
	width: 100%;
	flex-direction: column;
	height: 100vh;
	padding: 16px;
	background: #F2F5F7;
	align-items: center;
`;

PassCodeContainer.InfoContainer = styled.div`
	display: flex;
	max-width: 358px;
	width: 100%;
	height: fit-content;
	flex-direction: column;
	background: #FFFFFF;
	padding: 16px;
	border-radius: 12px;
`;
